// services/categoryService.js
import api from './api';

/**
 * Получение списка всех категорий с параметрами фильтрации
 * @param {Object} params - Параметры запроса
 * @param {boolean} includeInactive - Включать ли неактивные записи
 * @returns {Promise<Array>} Массив категорий
 */
export const getCategories = async (params = {}, includeInactive = true) => {
  // Добавляем параметр для включения неактивных записей
  const queryParams = { 
    ...params,
    includeInactive: includeInactive 
  };
  
  const response = await api.get('/categories', { params: queryParams });
  return response.data;
};

/**
 * Получение категории по ID
 * @param {number} id - ID категории
 * @returns {Promise<Object>} Данные категории
 */
export const getCategoryById = async (id) => {
  const response = await api.get(`/categories/${id}`);
  return response.data;
};

/**
 * Создание новой категории
 * @param {Object} categoryData - Данные для создания категории
 * @returns {Promise<Object>} Созданная категория
 */
export const createCategory = async (categoryData) => {
  const response = await api.post('/categories', categoryData);
  return response.data;
};

/**
 * Обновление существующей категории
 * @param {number} id - ID категории
 * @param {Object} categoryData - Данные для обновления
 * @returns {Promise<Object>} Обновленная категория
 */
export const updateCategory = async (id, categoryData) => {
  const response = await api.put(`/categories/${id}`, categoryData);
  return response.data;
};

/**
 * Деактивация категории (мягкое удаление через DELETE запрос)
 * @param {number} id - ID категории
 * @returns {Promise<Object>} Результат операции
 */
export const deactivateCategory = async (id) => {
  const response = await api.delete(`/categories/${id}`);
  return response.data;
};

/**
 * Активация категории (через обновление)
 * @param {number} id - ID категории
 * @param {Object} categoryData - Полные данные категории
 * @returns {Promise<Object>} Обновленная категория
 */
export const activateCategory = async (id, categoryData) => {
  // Добавляем поле isActive в true
  const dataWithActive = {
    ...categoryData,
    isActive: true
  };
  const response = await api.put(`/categories/${id}`, dataWithActive);
  return response.data;
};